import { take, put, call } from 'redux-saga/effects';
import {
    Actions,
    getDeviceTypesSuccess, getDeviceTypesFailure,
} from 'actions/deviceTypeActions';
import { apiGet } from './apiSagas';
import { DeviceTypeMap } from 'shared/models';
import { toError } from 'shared/util/toError';


export function* getDeviceTypesSaga() {
    while (true) {
        yield take(Actions.GET_DEVICETYPES_REQUEST);

        try {
            const deviceTypes: DeviceTypeMap = yield call(apiGet, '/api/device-types');
            yield put(getDeviceTypesSuccess(deviceTypes));
        }
        catch (e) {
            const err = toError(e);
            yield put(getDeviceTypesFailure(err));
        }
    }
}
